module.exports = __webpack_public_path__ + "img/title_next.03e4a69a.png";